import { render, staticRenderFns } from "./EditVideoTabLayout.vue?vue&type=template&id=e2c2c36a&"
import script from "./EditVideoTabLayout.vue?vue&type=script&lang=js&"
export * from "./EditVideoTabLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports